export default [
  {
    path: '/403',
    component: () => import('@/views/error/403.vue')
  },
  {
    path: '/404',
    component: () => import('@/views/error/404.vue')
  }
]
